import { graphql } from '@api/generated';

export const GET_SECOND_CHANCE_LEADS_FRONTEND_SETTINGS = graphql(`
  query secondChanceLeadsFrontendSettings($contactCenterId: ID!) {
    sclSettingsFrontEnd(contactCenterId: $contactCenterId) {
      daysUntilCold
    }
  }
`);
